// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".companyEvaluation_label {\n  height: 40px;\n  line-height: 40px;\n  color: black;\n  font-size: 16px;\n  text-align: left;\n}\n.companyEvaluation_Company {\n  width: -webkit-fill-available !important;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"companyEvaluation_label": "companyEvaluation_label",
	"companyEvaluation_Company": "companyEvaluation_Company"
};
module.exports = ___CSS_LOADER_EXPORT___;
